<template>
  <div class="space-y-1">
    <label v-if="label" id="listbox-label" class="block text-sm font-medium text-gray-700 mb-1 font-bold">
      {{ label }}
    </label>
    <div class="relative">
      <span class="inline-block w-full">
        <button
          type="button"
          aria-haspopup="listbox"
          aria-expanded="true"
          aria-labelledby="listbox-label"
          class="formkit-input block w-full bg-white rounded-md border border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] text-left cursor-pointer flex justify-between items-center"
          @click="showSelect = !showSelect"
        >
          <span class="block truncate">
            {{ selectedOption }}
          </span>
          <span class="pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="none" stroke="currentColor">
              <path d="M7 7l3-3 3 3m0 6l-3 3-3-3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>
      </span>

      <transition
        enter-active-class=""
        leave-active-class="transition ease-in duration-100"
        enter-class=""
        enter-to-class=""
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="showSelect"
          :class="`z-10 mt-1 w-full rounded-md bg-white shadow-lg min-w-[160px] ${floatDropdown && 'absolute'}`"
        >
          <ul
            tabindex="-1"
            role="listbox"
            aria-labelledby="listbox-label"
            aria-activedescendant="listbox-item-3"
            class="max-h-60 rounded-md py-1 text-base leading-6 overflow-auto focus:outline-none sm:text-sm"
          >
            <li
              v-for="option of options"
              :id="option"
              :key="option"
              role="option"
              class="hover:bg-gray-100 text-gray-900 cursor-pointer select-none relative py-2 pl-3 pr-9"
              @click="
                selectedOption = option;
                showSelect = false;
              "
            >
              <span :class="selectedOption == option ? 'font-semibold' : ''" class="font-normal block">
                {{ option }}
              </span>
              <span
                v-if="selectedOption == option"
                class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600"
              >
                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
      required: false,
    },
    initialValue: {
      type: String,
      default: '',
      required: true,
    },
    options: {
      type: Array,
      default: [],
      required: true,
    },
    floatDropdown: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      showSelect: false,
      selectedOption: this.initialValue === null ? this.options[0] : this.initialValue,
    };
  },
  watch: {
    selectedOption(val) {
      this.$emit('selectedOption', val);
      this.$emit('input', val);
    },
  },
  mounted() {
    const self = this;
    self.$emit('selectedOption', self.selectedOption);
  },
  methods: {},
};
</script>
